import _ from 'lodash';
import { ModeCollectionFactoryService } from '../model-collection.factory';
import { ModelAccessorInjectables } from '../model_accessor';
import { ModeModelBase } from '../model';
import { ModelAccessorBase } from '../model_accessor';
import { Injectable } from '@angular/core';

export class ReportSubscriptionModel extends ModeModelBase {
  override _name = 'reportSubscription';
  savedSlackMemberships: any;
  override belongsTo = 'report';
  override parentIdAttribute = 'token';
  override hasMany = [{ name: 'emailSubscriptionMemberships' }, { name: 'slackSubscriptionMemberships' }];
  override hasOne = [{ name: 'reportSchedule' }];
  override attributes = [
    { name: 'created_at', default: null },
    { name: 'updated_at', default: null },
    { name: 'email_subscriber_count', default: null },
    { name: 'slack_subscriber_count', default: null },
    { name: 'pdf_attachments_enabled', default: false },
    { name: 'csv_attachments_enabled', default: false },
    { name: 'data_previews_enabled', default: false },
    { name: 'data_tables_enabled', default: false },
    { name: 'report_links_enabled', default: false },
  ];
  override initialize(resource) {
    if (resource && resource.hasForm('edit')) {
      _.merge(this, resource.forms('edit').$serialize().report_subscription);
    }
  }
  insertSlackMembership(membership) {
    if (this.savedSlackMemberships && this.savedSlackMemberships.length) {
      this.savedSlackMemberships.push(membership);
    } else {
      this.savedSlackMemberships = [membership];
    }
  }
  destroySavedSlackMemberships() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    return self.injectables.$q
      .all(
        _.map(this.savedSlackMemberships, (membership) => {
          return membership.destroy();
        })
      )
      .then(() => {
        self.savedSlackMemberships = null;
      });
  }
}

@Injectable({ providedIn: 'root' })
export class ReportSubscriptionModelAccessor extends ModelAccessorBase<ReportSubscriptionModel> {
  override name = 'reportSubscription';
  override parentModel = 'report';
  override parentIdAttribute = 'token';
  override createAttributes = ['report'];
  constructor(
    injectables: ModelAccessorInjectables,
    private ModeCollection: ModeCollectionFactoryService
  ) {
    super(injectables, 'migrated', 'mode.reportSubscription');
  }
  buildSlackMemberships(subscription) {
    return subscription.savedSlackMemberships
      ? subscription
      : subscription
          .slackSubscriptionMemberships({ useEntryPath: true })
          .then(this.ModeCollection.elements)
          .then((slackMemberships) => {
            subscription.savedSlackMemberships = slackMemberships;
            return subscription;
          });
  }
  buildSubscriptionWithSlackMembership(subscription) {
    //@ts-ignore
    return this.injectables.$q.all(_.map(subscription, this.buildSlackMemberships.bind(this)));
  }
  createModel(resource, opts?) {
    const model = new ReportSubscriptionModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
